import { get, post, put, remove } from "../base";

export const uploadSalePrices = (data, onSuccess, onError) => {
  return post(
    "/api/economics/upload/sale_prices/",
    data,
    null,
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const getSalePricesDict = (onSuccess, onError) => {
  return get(
    "/api/economics/upload/sale_prices/dict/",
    {},
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const uploadLoeExpense = (data, onSuccess, onError) => {
  return post(
    "/api/economics/upload/loe_expense/",
    data,
    null,
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const getLoseExpenseDict = (onSuccess, onError) => {
  return get(
    "/api/economics/upload/loe_expense/dict/",
    {},
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const uploadOwnership = (data, onSuccess, onError) => {
  return post(
    "/api/economics/upload/ownership/",
    data,
    null,
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const getOwnershipDict = (onSuccess, onError) => {
  return get(
    "/api/economics/upload/ownership/dict/",
    {},
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const uploadAfe = (data, onSuccess, onError) => {
  return post(
    "/api/economics/upload/afe/",
    data,
    null,
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};

export const getAfeDict = (onSuccess, onError) => {
  return get(
    "/api/economics/upload/afe/dict/",
    {},
    {},
    (res) => {
      onSuccess?.(res.data);
    },
    (error) => {
      console.error(error);
      onError?.(error);
    }
  );
};
